import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.sass'],
  animations: [
    trigger("smoothCollapse", [
      state("initial", style({
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        opacity: 0
      })),
      state("final", style({
        overflow: "hidden",
      })),
      transition("initial<=>final", animate("250ms"))
  ]), 
  trigger('rotatedState', [
    state('default', style({ transform: 'rotate(0)' })),
    state('rotated', style({ transform: 'rotate(90deg)' })),
    transition('rotated <=> default', animate('250ms')),
  ])
  ],
  standalone: true,
  imports: []
})
export class AccordionItemComponent implements OnInit {
  @Input() title!: string;
  @Input() sectorId!: any;
  @Input() accordionType!: string;
  showBody = false;
  constructor() { }

  ngOnInit(): void {}

  toggle(event: any) {
    let clickedELement: any;
    
    if(event.classList.contains("header-title")) {
      clickedELement = event.parentElement.nextSibling;
    } else if(event.classList.contains("acc-header")) {
      clickedELement = event.nextSibling;
    } else if(event.classList.contains("ion-ios-arrow-down")) {      
      clickedELement = event.parentElement.parentElement.nextSibling;
    }

    if(clickedELement.classList.contains("open-accordion-sector")) {
      clickedELement.classList.add("open-accordion-sector-fade")
      setTimeout(() => {
        clickedELement.classList.remove("open-accordion-sector")
        clickedELement.classList.remove("open-accordion-sector-fade")
      }, 700);
      this.showBody = this.showBody;
    } else if(clickedELement.classList.contains("open-accordion-group-sector")) {
      clickedELement.classList.add("open-accordion-sector-fade")
      setTimeout(() => {
        clickedELement.classList.remove("open-accordion-group-sector")
        clickedELement.classList.remove("open-accordion-sector-fade")
      }, 700);
      this.showBody = this.showBody;
    } else {
      this.showBody = !this.showBody;
    }
  }
}
